export default __webpack_public_path__ + "static/media/Trophy.b8e289d4.svg";